import { gql } from "@apollo/client";

export const UPDATE_BRAND_USER_STATUS = gql`
  mutation UpdateBrandUserStatus($params: BrandUserStatusInput!) {
    updateBrandUserStatus(params: $params) {
      brandUserId
      brandUserName
      brandUserEmail
      brandAppUserId
      brandUserIsActive
      brandUserCreatedAt
      brandUserCreatedBy
      brandOrganizationUserId
      brandUserRoles {
        brandUserRoleId
        brandUserRoleAppId
        brandUserRoleKey
        brandUserRoleName
        brandUserRoleDescription
      }
    }
  }
`;

